import FacebookIcon from "@mui/icons-material/Facebook";
import WarningIcon from "@mui/icons-material/Warning";
import { Link } from "@mui/material";
import React, { useCallback } from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import FacebookLogin from "@/lib/FacebookLogin";
import { WhatsappAccountConnectionMessages } from "@/messages/platforms/whatsappConnection/whatsappAccountConnectionMessages";

interface MetaLogin {
  phone_number_id: number;
  waba_id: number;
}

interface Props {
  messages: WhatsappAccountConnectionMessages;
  onCompleteMetaLogin: ({ phone_number_id, waba_id }: MetaLogin) => void;
}

export function AccountConnection({ messages, onCompleteMetaLogin }: Props) {
  const handleResolveConnection = useCallback(
    ({ phone_number_id, waba_id }: MetaLogin) => {
      onCompleteMetaLogin({ phone_number_id, waba_id });
    },
    [onCompleteMetaLogin]
  );

  return (
    <MDBox>
      <MDBox width="82%" textAlign="left" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="body2" color="text">
            {messages.whatsappAccountConnectionText1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          {messages.whatsappAccountConnectionText2}
        </MDTypography>

        <MDTypography variant="body2" color="text">
          {messages.whatsappAccountConnectionText3}
          <Link target="_blank" href={messages.whatsappAccountConnectionWhatsappServiceTermsSource}>
            <MDTypography component="span" variant="body2" fontWeight="bold" color="primary">
              {messages.whatsappAccountConnectionWhatsappServiceTermsText}
            </MDTypography>
          </Link>
        </MDTypography>

        <MDBox my={1}>
          <MDTypography
            variant="body2"
            color="dark"
            display={"flex"}
            alignItems={"center"}
            fontWeight={"bold"}
            textAlign={"left"}
          >
            <WarningIcon sx={{ marginRight: "4px", color: "#f6cf34" }} />
            {messages.whatsappAccountConnectionImportantNote}
          </MDTypography>
        </MDBox>
      </MDBox>

      <MDBox width="82%" mx="auto" my={4}>
        <FacebookLogin
          appId={import.meta.env.VITE_META_APP_ID!}
          config_id={import.meta.env.VITE_META_CONFIG_ID!}
          onResolve={handleResolveConnection}
        >
          <MDButton variant="contained" color="info" startIcon={<FacebookIcon />}>
            {messages.connectWithFacebookButton}
          </MDButton>
        </FacebookLogin>
      </MDBox>
    </MDBox>
  );
}
